import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaMoneyBillWave, FaShoppingCart } from 'react-icons/fa';
import ReactPixel from 'react-facebook-pixel';
import { v4 as uuidv4 } from 'uuid';
import sha256 from 'crypto-js/sha256';
import ReactGA from "react-ga4";
import { getUTMHistory } from '../hooks/useUTM'; // ✅
import AppConfig from '../config/appConfig'; // path আপনার ফোল্ডার স্ট্রাকচার অনুযায়ী ঠিক করুন


function CheckoutPage({ setCart, addOrder }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, getAuthHeaders, fetchUserInfo, login } = useAuth(); // ✅ login add করো
  const eventId = uuidv4();

  const cartItems = location.state?.cartItems || [];
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    notes: '',
  });
  const nameInputTimer = useRef(null);
  const phoneInputTimer = useRef(null);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('cashOnDelivery');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [bkashTrxId, setBkashTrxId] = useState('');
  const [bkashPhoneNo, setBkashPhoneNo] = useState('');
  const [paymentModalError, setPaymentModalError] = useState('');
  const [paymentDetailsConfirmed, setPaymentDetailsConfirmed] = useState(false);
  const [mainFormError, setMainFormError] = useState('');

  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState('');
  const [couponSuccess, setCouponSuccess] = useState('');

  const [showAuthPrompt, setShowAuthPrompt] = useState(false);
  const [isOrderPlacing, setIsOrderPlacing] = useState(false);

  const [deliveryOption, setDeliveryOption] = useState('');

  const [selectedDivisionName, setSelectedDivisionName] = useState('');
  const [selectedDistrictName, setSelectedDistrictName] = useState('');
  const [selectedUpazilaName, setSelectedUpazilaName] = useState('');
  const [selectedUnionName, setSelectedUnionName] = useState('');

  const [isValid, setIsValid] = useState(false);
  const [message, setMessage] = useState('');
  const [addressMessage, setAddressMessage] = useState('Enter your address or click auto-fill');

  const bKashAgentNumber = '017XXXXXXXX';
  const nagadAgentNumber = '018XXXXXXXX';

  const [divisions, setDivisions] = useState([]);
  const [selectedDivisionId, setSelectedDivisionId] = useState('');
  const [districts, setDistricts] = useState([]);
  const [selectedDistrictId, setSelectedDistrictId] = useState('');
  const [upazilas, setUpazilas] = useState([]);
  const [selectedUpazilaId, setSelectedUpazilaId] = useState('');
  const [unions, setUnions] = useState([]);
  const [selectedUnionId, setSelectedUnionId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deliveryCharges, setDeliveryCharges] = useState({ insideDhaka: 70, outsideDhaka: 120 }); // fallback default
const [chargesLoaded, setChargesLoaded] = useState(false);

  // ✅ Updated API URL from file 1
  const API_BASE_URL = 'https://division-api.sparkx-ai.shop/api';

  const [isOrderButtonEnabled, setIsOrderButtonEnabled] = useState(false);
  const [orderId] = useState(uuidv4());
  const clientId = localStorage.getItem('client_id');
  const hasFiredRef = useRef(false);

  function getFbClickId() {
    const match = document.cookie.match(/_fbc=([^;]*)/);
    return match ? match[1] : null;
  }
  function getFbBrowserId() {
    const match = document.cookie.match(/_fbp=([^;]*)/);
    return match ? match[1] : null;
  }

  useEffect(() => {
    // if ((selectedPaymentMethod === 'bkash' || selectedPaymentMethod === 'nagad') && !paymentDetailsConfirmed) {
    //   setShowPaymentModal(true);
    // } else {
    //   setShowPaymentModal(false);
    // }

    if (selectedPaymentMethod === 'cashOnDelivery') {
      setPaymentDetailsConfirmed(true);
      setBkashTrxId('');
      setBkashPhoneNo('');
    }
    // else if (selectedPaymentMethod === 'bkash' || selectedPaymentMethod === 'nagad') {
    //   if (!paymentDetailsConfirmed) {
    //     setPaymentDetailsConfirmed(false);
    //   }
    // }
  }, [selectedPaymentMethod, paymentDetailsConfirmed]);


  useEffect(() => {
  const fetchDeliveryCharges = async () => {
    try {
      const response = await fetch(`${AppConfig.API_BASE_URL}/api/delivery-charges`);
      const data = await response.json();
      if (data.success) {
        setDeliveryCharges({
          insideDhaka: data.insideDhaka,
          outsideDhaka: data.outsideDhaka,
        });
      }
    } catch (error) {
      console.error('Error fetching delivery charges:', error);
      // fallback default value গুলোই থেকে যাবে
    } finally {
      setChargesLoaded(true);
    }
  };

  fetchDeliveryCharges();
}, []);





  useEffect(() => {
    if (!cartItems || cartItems.length === 0 || hasFiredRef.current) return;

    const evId = uuidv4();
    const externalId = localStorage.getItem('client_id') || orderId;
    const totalCartValue = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
    const contentsArray = cartItems.map(item => ({
      id: item.productId, quantity: item.quantity, item_price: item.price,
    }));
    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const evTime = Math.floor(Date.now() / 1000);

    // Browser Pixel
    ReactPixel.track('InitiateCheckout', {
      content_ids: cartItems.map(item => item.productId),
      contents: contentsArray,
      content_type: 'product',
      num_items: cartItems.reduce((sum, item) => sum + item.quantity, 0),
      value: totalCartValue,
      currency: 'BDT',
      event_id: evId,
    }, { fbc, fbp, external_id: externalId });

    // GA4
    ReactGA.event('initiate_checkout', {
      currency: 'BDT',
      value: totalCartValue,
      items: cartItems.map(item => ({
        item_id: item.productId,
        item_name: item.name || 'Unknown',
        price: item.price,
        quantity: item.quantity,
      })),
    });

    // Conversion API (server-side)
    fetch(`${AppConfig.API_BASE_URL}/track/initiate_checkout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_id: evId,
        cart_items: cartItems,
        total_value: totalCartValue,
        currency: 'BDT',
        event_time: evTime,
        fbc, fbp,
        external_id: externalId,
      }),
    }).catch(err => console.error('IC CAPI error:', err));

    hasFiredRef.current = true;
  }, [cartItems]);

  useEffect(() => {
    const isFormFilled = formData.name.trim() !== '' && formData.phone.trim() !== '' && formData.address.trim() !== '';
    const isPaymentSelected = selectedPaymentMethod !== '';
    const isDeliveryOptionSelected = deliveryOption !== '';

    let isPaymentConfirmed = false;
    if (selectedPaymentMethod === 'cashOnDelivery') {
      isPaymentConfirmed = true;
    }
    // else if (selectedPaymentMethod === 'bkash' || selectedPaymentMethod === 'nagad') {
    //   isPaymentConfirmed = paymentDetailsConfirmed;
    // }
    else {
      isPaymentConfirmed = false;
    }

    setIsOrderButtonEnabled(isFormFilled && isPaymentSelected && isDeliveryOptionSelected && isPaymentConfirmed && cartItems.length > 0 && selectedDivisionId.length > 0 && selectedDistrictId.length > 0 && isValid);
  }, [formData, selectedPaymentMethod, paymentDetailsConfirmed, deliveryOption, cartItems, selectedDivisionId, selectedDistrictId, isValid]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === 'name' || name === 'phone') {
      if (name === 'name') {
        clearTimeout(nameInputTimer.current);
      } else {
        clearTimeout(phoneInputTimer.current);
        const checkValidity = (num) => {
          const digitsOnly = num.replace(/[^0-9+]/g, '');

          if (digitsOnly === '') {
            setIsValid(false);
            setMessage('Phone number cannot be empty.');
            return;
          }

          if (digitsOnly.startsWith('+88')) {
            const numberWithoutCountryCode = digitsOnly.slice(1);

            if (numberWithoutCountryCode.length === 13) {
              if (/^\d+$/.test(numberWithoutCountryCode)) {
                setIsValid(true);
                setMessage('Valid phone number.');
              } else {
                setIsValid(false);
                setMessage('Use digits only.');
              }
            } else {
              setIsValid(false);
              setMessage('Provide 13 digits including +88.');
            }
          } else {
            if (digitsOnly.length === 11) {
              if (/^\d+$/.test(digitsOnly)) {
                setIsValid(true);
                setMessage('Valid phone number.');
              } else {
                setIsValid(false);
                setMessage('Use digits only.');
              }
            } else {
              setIsValid(false);
              setMessage('Provide 11-digit phone number.');
            }
          }
        };

        checkValidity(value);
      }

      const timer = setTimeout(() => {
        sendRealtimeDataToFlask(name, value);
      }, 500);
      if (name === 'name') {
        nameInputTimer.current = timer;
      } else {
        if (isValid) {
          phoneInputTimer.current = timer;
        }
      }
    } else if (name === 'address') {
      if (formData.address.trim() === '') {
        setAddressMessage('Enter your address or click auto-fill');
      } else {
        setAddressMessage('');
      }
    }
  };

  const sendRealtimeDataToFlask = async (fieldName, fieldValue) => {
    const clientId = localStorage.getItem('client_id');
    const today = new Date();
    const dateOnly = today.toDateString();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    try {
      const response = await fetch(`${AppConfig.API_BASE_URL}/api/realtime-input`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          field: fieldName,
          value: fieldValue,
          visitPageDate: dateOnly,
          ServerAPICallingDate: `${day}-${month}-${year}`,
          clientId: clientId,
          cartItems: cartItems.map(item => ({
            productId: item.id,
            name: item.name,
            quantity: item.quantity,
            price: item.price,
            image: item.image,
            originalPrice: item.originalPrice || item.price,
            selectedSize: item.selectedSize || null,
            selectedColor: item.selectedColor ? item.selectedColor.name : null,
          })),
        }),
      });
      if (response.ok) {
        console.log(`Real-time data sent successfully for ${fieldName}: ${fieldValue}`);
      } else {
        const errorData = await response.json();
        console.error(`Failed to send real-time data for ${fieldName}:`, errorData.error);
      }
    } catch (error) {
      console.error(`Error sending real-time data for ${fieldName}:`, error);
    }
  };

  const calculateSubtotal = () => {
    return cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
  };

  const calculateDiscount = () => {
    if (!appliedCoupon) return 0;

    const subtotal = calculateSubtotal();
    if (appliedCoupon.discount_type === 'percentage') {
      return (subtotal * appliedCoupon.discount_value) / 100;
    } else if (appliedCoupon.discount_type === 'fixed') {
      return appliedCoupon.discount_value;
    }
    return 0;
  };

  const calculateTotalPAW = () => {
    return cartItems.reduce((acc, item) => {
      const pawValue = typeof item.PAW === 'number' ? item.PAW : 0;
      return acc + (pawValue * item.quantity);
    }, 0);
  };

  const calculateTotalPCW = () => {
    return cartItems.reduce((acc, item) => {
      const pcwValue = typeof item.PCW === 'number' ? item.PCW : 0;
      return acc + (pcwValue * item.quantity);
    }, 0);
  };

  const totalPAW = calculateTotalPAW();
  const totalPCW = calculateTotalPCW();

  const calculateTotalRevenue = () => {
    let totalRevenue = 0;
    cartItems.forEach(item => {
      const price = typeof item.price === 'number' ? item.price : 0;
      const buyingPrice = typeof item.buyingPrice === 'number' ? item.buyingPrice : 0;
      const quantity = typeof item.quantity === 'number' ? item.quantity : 0;

      const itemRevenue = (price - buyingPrice) * quantity;

      totalRevenue += itemRevenue;
    });
    return totalRevenue;
  };

  const totalRevenue = calculateTotalRevenue();

const getDeliveryChargeInfo = () => {
  let charge = 0;
  let display = '';
  let isFree = false;

  const insideCharge = deliveryCharges.insideDhaka;
  const outsideCharge = deliveryCharges.outsideDhaka;

  if (totalPCW === 0) {
    charge = 0;
    display = 'Free';
    isFree = true;
  } else if (totalPCW > 0 && totalPCW <= 1) {
    if (deliveryOption === 'insideDhaka') {
      charge = insideCharge;
      display = `৳${insideCharge}`;
    } else if (deliveryOption === 'outsideDhaka') {
      charge = outsideCharge;
      display = `৳${outsideCharge}`;
    } else {
      charge = 0;
      display = 'Select option';
    }
  } else if (totalPCW > 1) {
    if (deliveryOption === 'insideDhaka') {
      charge = Math.round(totalPCW * insideCharge);
      display = `৳${charge}`;
    } else if (deliveryOption === 'outsideDhaka') {
      charge = Math.round(totalPCW * outsideCharge);
      display = `৳${charge}`;
    } else {
      charge = 0;
      display = 'Select option';
    }
  }

  return { chargeForApi: charge, displayCharge: display, isFree: isFree };
};

  const { chargeForApi, displayCharge, isFree } = getDeliveryChargeInfo();

  const calculateACDC = () => {
    if (totalPAW === 0) {
      return 0;
    } else if (totalPAW > 0 && totalPAW <= 0.5) {
      return 50;
    } else if (totalPAW > 0.5 && totalPAW <= 1) {
      return 75;
    } else {
      return Math.round(totalPAW * 60);
    }
  };

  const acdcValue = calculateACDC();

  let actualTotalRevenue = totalRevenue;

  if (totalPCW === 0) {
    actualTotalRevenue = totalRevenue - acdcValue;
  }

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discount = calculateDiscount();
    return Math.max(0, subtotal - discount);
  };

  const calculateTotalOriginalPrice = () => {
    return cartItems.reduce((acc, item) => acc + (item.originalPrice || item.price) * item.quantity, 0);
  };

  const calculateOverallSavings = () => {
    const totalOriginalPrice = calculateTotalOriginalPrice();
    const subtotalCurrentPrice = calculateSubtotal();
    const itemWiseSavings = totalOriginalPrice - subtotalCurrentPrice;
    const couponSavings = calculateDiscount();

    return itemWiseSavings + couponSavings;
  };

  const handlePaymentMethodChange = (method) => {
    setSelectedPaymentMethod(method);
    setPaymentDetailsConfirmed(false);
    setMainFormError('');
  };

  const handleDeliveryOptionChange = (option) => {
    setDeliveryOption(option);
    setMainFormError('');
  };

  const handlePaySubmit = () => {
    setPaymentModalError('');
    if (!bkashTrxId.trim()) {
      setPaymentModalError('TrxID cannot be empty.');
      return;
    }
    if (!/^\d{11}$/.test(bkashPhoneNo)) {
      setPaymentModalError('Provide valid 11-digit mobile number.');
      return;
    }

    setPaymentDetailsConfirmed(true);
    setShowPaymentModal(false);
  };

  const handleApplyCoupon = async () => {
    setCouponError('');
    setCouponSuccess('');
    setAppliedCoupon(null);

    if (!couponCode.trim()) {
      setCouponError('Coupon code cannot be empty.');
      return;
    }

    const clientId = localStorage.getItem('client_id');
    try {
      const response = await fetch(`${AppConfig.API_BASE_URL}/apply_coupon`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          coupon_code: couponCode,
          cart_total: calculateSubtotal(),
          client_id: clientId
        }),
      });
      const data = await response.json();

      if (response.ok) {
        setAppliedCoupon(data.coupon);
        setCouponSuccess(data.message);
      } else {
        setCouponError(data.error);
        if (response.status === 401) {
          setCouponError('Your session has expired. Please login again.');
        } else if (response.status === 429) {
          setCouponError(data.error);
        }
      }
    } catch (error) {
      console.error('Error applying coupon:', error);
      setCouponError('Error applying coupon.');
    }
  };

  const updateCouponUsage = async (code) => {
    try {
      const response = await fetch(`${AppConfig.API_BASE_URL}/use_coupon`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ coupon_code: code, client_id: clientId }),
      });
      if (response.ok) {
        console.log(`Coupon ${code} usage updated.`);
      } else {
        const errorData = await response.json();
        console.error(`Error updating coupon usage: ${errorData.error}`);
      }
    } catch (error) {
      console.error('Error updating coupon usage:', error);
    }
  };

  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    setMainFormError('');
    if (!isOrderButtonEnabled) {
      setMainFormError('Please fill all required information.');
      return;
    }

    proceedToOrderSubmission();
  };

  const eventTime = Math.floor(Date.now() / 1000);

  const proceedToOrderSubmission = async () => {
    setIsOrderPlacing(true);
    setMainFormError('');

    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const utmHistory = getUTMHistory(); // ✅ এই line যোগ করো

    const orderSummary = {
      orderId: `${orderId}`,
      orderDate: new Date().toLocaleDateString(),
      orderTime: new Date().toLocaleTimeString(),
      eventTime: eventTime,
      customerInfo: formData,
      division: selectedDivisionName,
      district: selectedDistrictName,
      upazila: selectedUpazilaName != null ? selectedUpazilaName : "Not selected",
      cartItems: cartItems.map(item => ({
        productId: item.productId,
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        image: item.image,
        originalPrice: item.originalPrice || item.price,
        selectedSize: item.selectedSize || null,
        selectedColor: item.selectedColor ? item.selectedColor.name : null,
        PAW: typeof item.PAW === 'number' ? item.PAW : 0,
        PCW: typeof item.PCW === 'number' ? item.PCW : 0,
        buyingPrice: typeof item.buyingPrice === 'number' ? item.buyingPrice : 0,
      })),
      subtotalAmount: calculateSubtotal(),
      discountAmount: calculateDiscount(),
      CustomerDeliveryCharge: chargeForApi,
      AdjustedCustomerDeliveryCharge: acdcValue,
      totalAmount: calculateTotal(),
      paymentMethod: selectedPaymentMethod,
      // paymentDetails: (selectedPaymentMethod === 'bkash' || selectedPaymentMethod === 'nagad') && paymentDetailsConfirmed
      //   ? { trxId: bkashTrxId, phoneNo: bkashPhoneNo }
      //   : null,
      paymentDetails: null,
      appliedCouponCode: appliedCoupon ? appliedCoupon.code : null,
      status: 'Processing',
      reviewAdded: false,
      clientId: clientId,
      totalPAW: totalPAW,
      totalPCW: totalPCW,
      totalRevenue: totalRevenue,
      ActualTotalRevenue: actualTotalRevenue,
      deliveryOption: deliveryOption,
      fbc: fbc,
      fbp: fbp,
      external_id: clientId,
      tracking_history: utmHistory,
    };





    const contents = orderSummary.cartItems.map(item => ({
      id: item.productId, quantity: item.quantity, item_price: item.price,
      content_name: item.name, content_category: 'Product',
    }));

    const nameParts = orderSummary.customerInfo.name.trim().split(/\s+/);
    const userData = {
      ph: sha256(orderSummary.customerInfo.phone.replace(/\D/g, '')).toString(),
      fn: sha256(nameParts[0].toLowerCase()).toString(),
      ...(nameParts.length > 1 && { ln: sha256(nameParts.slice(1).join(' ').toLowerCase()).toString() }),
      country: sha256('bd').toString(),
      ct: sha256(selectedDistrictName.toLowerCase()).toString(),
      st: sha256(selectedDivisionName.toLowerCase()).toString(),
      external_id: clientId, fbc, fbp,
    };

    ReactPixel.track('Purchase', {
      value: orderSummary.totalAmount,
      currency: 'BDT',
      content_ids: orderSummary.cartItems.map(item => item.productId),
      contents,
      content_type: 'product',
      num_items: orderSummary.cartItems.reduce((sum, item) => sum + item.quantity, 0),
      event_id: orderSummary.orderId,
    }, userData);

    ReactGA.event('purchase', {
      currency: 'BDT',
      value: orderSummary.totalAmount,
      items: contents,
      shipping: acdcValue,
      payment_method: orderSummary.paymentMethod,
      event_id: orderSummary.orderId,
    });


    try {
      const response = await fetch(`${AppConfig.API_BASE_URL}/place_order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderSummary),
      });
      const data = await response.json();
      if (response.ok) {
        console.log('Order successfully placed:', data.message);

        // ✅ NEW: Auto-login handling
        if (data.access_token && data.user_info) {
          localStorage.setItem('access_token', data.access_token);
          localStorage.setItem('user_info', JSON.stringify(data.user_info));


          // Auth context update করো (তোমার login function use করো)
          if (typeof login === 'function') {
            login(data.access_token, data.user_info);
          }

          localStorage.setItem('just_logged_in', 'true');

          console.log(data.auto_registered ? '✅ Account created!' : '✅ Logged in!');
        }

        if (appliedCoupon) {
          await updateCouponUsage(appliedCoupon.code);
        }

        setCart([]);
        navigate('/thank-you', { state: { orderSummary: data.order } });
      } else {
        setMainFormError(data.error || 'Failed to place order.');
        console.error('Failed to place order:', data.error);
      }
    } catch (error) {
      console.error('Error placing order:', error);
      setMainFormError('Network error placing order.');
    } finally {
      setIsOrderPlacing(false);
    }
  };

  const handleAuthPromptGuestCheckout = () => {
    proceedToOrderSubmission();
  };

  useEffect(() => {
    const fetchDivisions = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/divisions`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data && data.data) {
          setDivisions(data.data);
        } else {
          setError("Division data in unexpected format.");
        }
      } catch (err) {
        console.error("Failed to load divisions:", err);
        setError(`Error loading divisions: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchDivisions();
  }, []);

  useEffect(() => {
    const fetchDistricts = async () => {
      if (!selectedDivisionId) {
        setDistricts([]);
        setSelectedDistrictId('');
        setUpazilas([]);
        setSelectedUpazilaId('');
        setUnions([]);
        setSelectedUnionId('');
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/division/${selectedDivisionId.toLowerCase()}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data && data.data) {
          setDistricts(data.data);
          setSelectedDistrictId('');
          setUpazilas([]);
          setSelectedUpazilaId('');
          setUnions([]);
          setSelectedUnionId('');
        } else {
          setError("District data in unexpected format.");
        }
      } catch (err) {
        console.error("Failed to load districts:", err);
        setError(`Error loading districts: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchDistricts();
  }, [selectedDivisionId]);

  useEffect(() => {
    if (!selectedDistrictId) {
      setUpazilas([]);
      setSelectedUpazilaId('');
      setUnions([]);
      setSelectedUnionId('');
      return;
    }
    const found = districts.find(d => d.district === selectedDistrictId);
    if (found) {
      setUpazilas(found.upazilla || []);
      setSelectedUpazilaId('');
      setUnions([]);
      setSelectedUnionId('');
    }
  }, [selectedDistrictId, districts]);

  useEffect(() => {
    const fetchUnions = async () => {
      if (!selectedUpazilaId) {
        setUnions([]);
        setSelectedUnionId('');
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/union/${selectedUpazilaId}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data && data.data) {
          setUnions(data.data);
          setSelectedUnionId('');
        } else {
          setError("Union data in unexpected format.");
        }
      } catch (err) {
        console.error("Failed to load unions:", err);
        setError(`Error loading unions: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchUnions();
  }, [selectedUpazilaId]);

  const handleDivisionChange = (event) => {
    const selectedId = event.target.value;
    setSelectedDivisionId(selectedId);
    const foundDivision = divisions.find(d => d.division === selectedId);
    if (foundDivision) {
      setSelectedDivisionName(foundDivision.divisionbn);
    } else {
      setSelectedDivisionName("");
    }
  };

  const handleDistrictChange = (event) => {
    const selectedId = event.target.value;
    setSelectedDistrictId(selectedId);
    const foundDistrict = districts.find(d => d.district === selectedId);

    if (foundDistrict) {
      setSelectedDistrictName(foundDistrict.district);

      // Auto set delivery option based on district
      if (foundDistrict.district === 'Dhaka') {
        setDeliveryOption('insideDhaka');
      } else if (foundDistrict.district !== '') {
        setDeliveryOption('outsideDhaka');
      }
    } else {
      setSelectedDistrictName("");
      setDeliveryOption('');
    }
  };

  const updateQuantity = (productId, newQuantity) => {
    const updatedItems = cartItems.map(item => {
      if (item.id === productId) {
        return { ...item, quantity: newQuantity };
      }
      return item;
    }).filter(item => item.quantity > 0);

    navigate(location.pathname, {
      replace: true,
      state: { cartItems: updatedItems },
    });
  };

  const removeItem = (productId) => {
    const updatedItems = cartItems.filter(item => item.id !== productId);

    navigate(location.pathname, {
      replace: true,
      state: { cartItems: updatedItems },
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const nameVal = document.getElementById("name")?.value || "";
      const phoneVal = document.getElementById("phone")?.value || "";
      const addressVal = document.getElementById("address")?.value || "";

      setFormData(prev => ({
        ...prev,
        name: nameVal,
        phone: phoneVal,
        address: addressVal
      }));
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: 'Assistant, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {/* Fixed Floating Cart Total - Shajgoj Style */}
      <div className="fixed right-4 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-2xl px-4 py-3 z-50 border border-gray-200 flex flex-col items-center gap-1 min-w-[90px]">
        <FaShoppingCart className="text-orange-600 text-2xl" />
        <div className="text-[10px] text-gray-500 font-medium uppercase tracking-wide">Total</div>
        <div className="text-lg font-bold text-orange-600" style={{ fontFamily: 'Assistant, sans-serif' }}>
          ৳{calculateTotal() + chargeForApi}
        </div>
      </div>

      {/* Main Container */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column - Form */}
          <div className="lg:col-span-2 space-y-4">
            <form onSubmit={handleOrderSubmit} className="space-y-4">
              {/* Shipping Address Card */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-bold text-gray-900">1. Shipping Address</h2>
                  <span className="text-sm text-gray-500">Required</span>
                </div>

                <div className="space-y-4">

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                      Mobile Number
                    </label>
                    <input
                      type="number"
                      autoComplete="off"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      onInput={handleInputChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
                    />
                    <p className={`text-xs mt-1 ${isValid ? 'text-green-600' : 'text-red-600'}`}>
                      {message}
                    </p>
                  </div>

                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      autoComplete="off"
                      onChange={handleInputChange}
                      onInput={handleInputChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
                    />
                  </div>



                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="division-select" className="block text-sm font-medium text-gray-700 mb-1">
                        Division
                      </label>
                      <select
                        id="division-select"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
                        value={selectedDivisionId}
                        onChange={handleDivisionChange}
                        disabled={loading}
                      >
                        <option value="">Select Division</option>
                        {divisions.map((division) => (
                          <option key={division.division} value={division.division}>
                            {division.divisionbn}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label htmlFor="district-select" className="block text-sm font-medium text-gray-700 mb-1">
                        District
                      </label>
                      <select
                        id="district-select"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
                        value={selectedDistrictId}
                        onChange={handleDistrictChange}
                        disabled={!selectedDivisionId || loading}
                      >
                        <option value="">Select District</option>
                        {districts.map((district) => (
                          <option key={district.district} value={district.district}>
                            {district.district}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">
                      Full Address
                    </label>
                    <textarea
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                      autoComplete="off"
                      onInput={handleInputChange}
                      rows="3"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all resize-none"
                    ></textarea>
                    <p className="text-xs text-red-600 mt-1">{addressMessage}</p>
                  </div>

                  <div>
                    <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1">
                      Order Notes (Optional)
                    </label>
                    <textarea
                      id="notes"
                      name="notes"
                      value={formData.notes}
                      onChange={handleInputChange}
                      rows="2"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all resize-none"
                    ></textarea>
                  </div>
                </div>
              </div>

              {/* Payment Method Card */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h2 className="text-xl font-bold text-gray-900 mb-4">3. Payment Method</h2>
                <div className="space-y-3">
                  <label
                    className={`flex items-center justify-between p-4 border-2 rounded-lg cursor-pointer transition-all ${selectedPaymentMethod === 'cashOnDelivery'
                      ? 'border-orange-500 bg-orange-50'
                      : 'border-gray-200 hover:border-orange-300'
                      }`}
                    onClick={() => handlePaymentMethodChange('cashOnDelivery')}
                  >
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id="cod"
                        name="paymentMethod"
                        value="cashOnDelivery"
                        checked={selectedPaymentMethod === 'cashOnDelivery'}
                        onChange={() => handlePaymentMethodChange('cashOnDelivery')}
                        className="w-4 h-4 text-orange-600 focus:ring-orange-500"
                      />
                      <span className="ml-3 text-sm font-medium text-gray-900">Cash on Delivery</span>
                    </div>
                    <FaMoneyBillWave className="text-green-600 text-2xl" />
                  </label>

                  {/* bKash option - commented out
                  <label
                    className={`flex items-center justify-between p-4 border-2 rounded-lg cursor-pointer transition-all ${selectedPaymentMethod === 'bkash'
                      ? 'border-orange-500 bg-orange-50'
                      : 'border-gray-200 hover:border-orange-300'
                      }`}
                    onClick={() => handlePaymentMethodChange('bkash')}
                  >
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id="bkash"
                        name="paymentMethod"
                        value="bkash"
                        checked={selectedPaymentMethod === 'bkash'}
                        onChange={() => handlePaymentMethodChange('bkash')}
                        className="w-4 h-4 text-orange-600 focus:ring-orange-500"
                      />
                      <span className="ml-3 text-sm font-medium text-gray-900">bKash</span>
                    </div>
                    <img
                      src="https://www.logo.wine/a/logo/BKash/BKash-bKash-Logo.wine.svg"
                      alt="bKash"
                      className="h-8 w-auto object-contain"
                    />
                  </label>
                  */}

                  {/* Nagad option - commented out
                  <label
                    className={`flex items-center justify-between p-4 border-2 rounded-lg cursor-pointer transition-all ${selectedPaymentMethod === 'nagad'
                      ? 'border-orange-500 bg-orange-50'
                      : 'border-gray-200 hover:border-orange-300'
                      }`}
                    onClick={() => handlePaymentMethodChange('nagad')}
                  >
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id="nagad"
                        name="paymentMethod"
                        value="nagad"
                        checked={selectedPaymentMethod === 'nagad'}
                        onChange={() => handlePaymentMethodChange('nagad')}
                        className="w-4 h-4 text-orange-600 focus:ring-orange-500"
                      />
                      <span className="ml-3 text-sm font-medium text-gray-900">Nagad</span>
                    </div>
                    <img
                      src="https://www.logo.wine/a/logo/Nagad/Nagad-Logo.wine.svg"
                      alt="Nagad"
                      className="h-8 w-auto object-contain"
                    />
                  </label>
                  */}

                  {/* bKash/Nagad confirmed box - commented out
                  {(selectedPaymentMethod === 'bkash' || selectedPaymentMethod === 'nagad') && paymentDetailsConfirmed && (
                    <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                      <p className="text-sm font-medium text-green-800 mb-1">Payment Details Submitted</p>
                      <p className="text-sm text-gray-700">TrxID: <strong>{bkashTrxId}</strong></p>
                      <p className="text-sm text-gray-700">Phone: <strong>{bkashPhoneNo}</strong></p>
                    </div>
                  )}
                  */}
                </div>
              </div>

              {/* Coupon Card */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Promo Code</h3>
                <div className="flex gap-2">
                  <input
                    type="text"
                    id="coupon"
                    name="coupon"
                    placeholder="Enter coupon code"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  />
                  <button
                    type="button"
                    onClick={handleApplyCoupon}
                    className="px-6 py-2 bg-orange-600 text-white font-medium rounded-md hover:bg-orange-700 transition-colors"
                  >
                    Apply
                  </button>
                </div>
                {couponError && <p className="text-sm text-red-600 mt-2">{couponError}</p>}
                {couponSuccess && <p className="text-sm text-green-600 mt-2">{couponSuccess}</p>}
              </div>

              {mainFormError && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <p className="text-sm text-red-600">{mainFormError}</p>
                </div>
              )}

              <button
                type="submit"
                disabled={!isOrderButtonEnabled || isOrderPlacing}
                className={`w-full py-4 rounded-lg font-bold text-lg transition-all ${isOrderButtonEnabled && !isOrderPlacing
                  ? 'bg-orange-500 hover:bg-orange-600 text-white shadow-md hover:shadow-lg'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
              >
                {isOrderPlacing ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Placing Order...
                  </span>
                ) : (
                  'Place Your Order'
                )}
              </button>
            </form>
          </div>

          {/* Right Column - Order Summary */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-24">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Order Summary</h3>

              {/* Cart Items */}
              <div className="space-y-4 mb-4 max-h-96 overflow-y-auto">
                {cartItems.map((item) => (
                  <div key={item.id} className="border-b border-gray-200 pb-4 last:border-0">
                    <div className="flex gap-3">
                      <img src={item.image} alt={item.name} loading="lazy" className="w-16 h-16 object-cover rounded" />
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-gray-900 truncate">{item.name}</h4>
                        <div className="flex items-center gap-2 mt-1">
                          {item.originalPrice && item.originalPrice > item.price && (
                            <>
                              <span className="text-xs text-gray-500 line-through">৳{item.originalPrice}</span>
                              <span className="text-xs text-green-600 font-medium">Save ৳{item.originalPrice - item.price}</span>
                            </>
                          )}
                        </div>
                        <div className="flex items-center justify-between mt-2">
                          <div className="flex items-center gap-2 bg-gray-100 rounded px-2 py-1">
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity - 1)}
                              disabled={item.quantity === 1}
                              className="text-gray-600 hover:text-gray-900 disabled:opacity-30"
                            >
                              −
                            </button>
                            <span className="text-sm font-medium w-8 text-center">{item.quantity}</span>
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity + 1)}
                              className="text-gray-600 hover:text-gray-900"
                            >
                              +
                            </button>
                          </div>
                          <button
                            onClick={() => removeItem(item.id)}
                            className="text-red-600 hover:text-red-700 text-sm font-medium"
                          >
                            Remove
                          </button>
                        </div>
                        <div className="text-sm font-semibold text-gray-900 mt-2">
                          ৳{item.price * item.quantity}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Price Breakdown */}
              <div className="space-y-2 border-t border-gray-200 pt-4">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Subtotal</span>
                  <span className="font-medium">৳{calculateSubtotal()}</span>
                </div>

                {appliedCoupon && (
                  <div className="flex justify-between text-sm">
                    <span className="text-green-600">Coupon ({appliedCoupon.code})</span>
                    <span className="font-medium text-green-600">-৳{calculateDiscount()}</span>
                  </div>
                )}

                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Delivery Charge</span>
                  <span className={`font-medium ${isFree ? 'text-green-600' : 'text-gray-900'}`}>
                    {isFree ? 'Free' : deliveryOption ? displayCharge : '৳0'}
                  </span>
                </div>

                {calculateOverallSavings() > 0 && (
                  <div className="flex justify-between text-sm bg-green-50 -mx-6 px-6 py-2">
                    <span className="text-green-700 font-medium">Total Savings</span>
                    <span className="font-bold text-green-700">৳{calculateOverallSavings()}</span>
                  </div>
                )}

                <div className="flex justify-between text-lg font-bold border-t border-gray-200 pt-3 mt-3">
                  <span>Order Total</span>
                  <span className="text-orange-600">৳{calculateTotal() + chargeForApi}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* bKash/Nagad Payment Modal - commented out
      {showPaymentModal && (selectedPaymentMethod === 'bkash' || selectedPaymentMethod === 'nagad') && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
            <button
              onClick={() => setShowPaymentModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl"
            >
              ×
            </button>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              {selectedPaymentMethod === 'bkash' ? 'bKash' : 'Nagad'} Payment
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Please send payment to the number below and provide details:
            </p>
            <p className="text-lg font-bold text-gray-900 mb-4 bg-gray-100 p-3 rounded">
              Agent Number: {selectedPaymentMethod === 'bkash' ? bKashAgentNumber : nagadAgentNumber}
            </p>
            <input
              type="text"
              placeholder="Transaction ID (e.g., 8H7J6K5L)"
              value={bkashTrxId}
              onChange={(e) => setBkashTrxId(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md mb-3 focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            />
            <input
              type="tel"
              placeholder="Your Mobile Number (11 digits)"
              value={bkashPhoneNo}
              onChange={(e) => setBkashPhoneNo(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md mb-3 focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            />
            {paymentModalError && <p className="text-sm text-red-600 mb-3">{paymentModalError}</p>}
            <button
              onClick={handlePaySubmit}
              className="w-full py-3 bg-orange-600 text-white font-bold rounded-lg hover:bg-orange-700 transition-colors"
            >
              Complete Payment
            </button>
          </div>
        </div>
      )}
      */}

      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-40">
          <div className="bg-white rounded-lg p-4 flex items-center gap-3">
            <svg className="animate-spin h-5 w-5 text-orange-600" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-gray-700 font-medium">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default CheckoutPage;